<template>
<div>
  
   <b-modal v-model="modalShow1" ok-only centered  class="text-center text-danger">
      Please enter valid config object
    </b-modal>
     <b-modal v-model="modalShow2" ok-only centered class="text-center text-info">
      Project Id Updated
    </b-modal>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
 
<div v-if="changed">

<div class="container mt-5">
   <div class="col-sm-12 col-md-6 m-auto">
      <h4 class="m-auto text-info text-center pt-4 pb-4">Enter Your Project Id</h4>
    <el-input
      requried
      placeholder="Please input your Project Id"
      v-model="inputObj"></el-input>
     <el-button type="primary" class="mt-3" @click="upConfig()">Update</el-button>
     <h4 class="m-auto text-info text-center pt-4 pb-2">How to Get Your Project Id</h4>
     <h6 class="m-auto text-dark text-center pt-2 pb-2">Go to the link shown below using your Gmail Address and do the steps shown in the video. It only takes a minute!</h6>
     <a class="text-info" href="https://console.firebase.google.com" target="_blank" rel="noopener noreferrer">https://console.firebase.google.com</a>
   </div>
</div> 
 </div>
 <div v-if="fetched" style="min-height:60vh;">
    <h4 class="m-auto text-info text-center pt-5 pb-5 my-5">Settings are Done!</h4>
  </div>
</div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
export default {
  name: 'setting',
  components: {
  },
  data() {
      return {
          image: "",
         modalShow1: false,
         modalShow2: false,
        dialogImageUrl: '',
        dialogVisible: false,
        visible: 'block',
        visible1: 'none',
        shops: [],
        inputObj:'',
        config:{},
        loading:false,
        loading1:false,
        fetched:false,
        changed:false,
        aboutimg:'',
        about:'',
        // fbConfig: {
        //   apiKey: "api-key",
        //   authDomain: "project-id.firebaseapp.com",
        //   databaseURL: "https://project-id.firebaseio.com",
        //   projectId: "project-id",
        //   storageBucket: "project-id.appspot.com",
        //   messagingSenderId: "sender-id",
        //   appID: "app-id",
        // }
      };
    },
    methods: {
      upConfig(){
         //console.log(this.shops[0].id)
         //console.log('uid',firebase.auth().currentUser.uid)
          this.loading = true
            this.changed = false
            this.config.projectId = this.inputObj
            // var properties = this.inputObj.split(',\n');
            // console.log('properties',properties)
            // properties.forEach((property) => {
            //     const tup = property.split(': ');
            //     this.config[tup[0]] = tup[1];
            //     console.log('this.config[tup[0]]',this.config[tup[0]])
            // })
            // console.log('this.config', this.config)
            console.log('this.config', this.config['projectId'])
            // console.log('this.config', this.config.apiKey)
            // console.log('this.config', this.config.databaseURL)
            if(this.config.projectId){
            this.config.authDomain = this.config.projectId+'.firebaseapp.com'
            this.config.databaseURL = 'https://'+this.config.projectId+'.firebaseio.com'
            this.config.storageBucket = this.config.projectId+'.appspot.com'
              // if(this.fbConfig.authDomain == this.config.authDomain &&
              // this.fbConfig.databaseURL == this.config.databaseURL && this.fbConfig.storageBucket == this.config.storageBucket){
                db.collection("shops").doc(this.shops[0].id)
                .update({
                config: this.config
                })
                .then(doc => {
                   var secondary = firebase.initializeApp(this.config, firebase.auth().currentUser.uid)
                  this.$store.state.secondaryDatabase = secondary.firestore()
                  // this.$store.state.secondaryApp = this.$route.params.storename
                  this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
                  this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
                      //console.log("Woohoo! Multi-Tab Persistence!");
                  });
                  this.$store.state.secondaryDatabase.collection("shops").add(this.shops[0])
                  .then( id=> {
                    console.log('secondaryDB shop id', id)
                  }).catch(error => alert(error));
                  console.log('secondaryDB', this.$store.state.secondaryDatabase)
                    this.loading = false
                  this.changed = false
                  this.fetched = true
                  this.modalShow2 = true
                  //console.log('doc is', doc)
                })
                .catch(error => alert(error));
              // }else{
              //   this.modalShow1 = true
              //    this.loading = false
              //     this.changed = true
              // }
            }else{
              this.modalShow1 = true
               this.loading = false
                  this.changed = true
            }
            
      },

		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
},

 created() {
   this.backToTop()
        this.loading1 = true
        this.changed =false
       db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).onSnapshot(querySnapshot => {
        this.shops = []
      querySnapshot.forEach(doc => {
        const data = {
          'config' : doc.data().config,
          'id':doc.id,
          'name': doc.data().name,
              'plan': doc.data().plan,
              'district': doc.data().district,
              'location': doc.data().location,
              'categories': doc.data().categories,
              'cat': doc.data().cat,
              'shoptype': doc.data().shoptype,
              'catValues': doc.data().catValues,
              'maxProducts':doc.data().maxProducts,
              'curProducts':doc.data().curProducts,
              'curOffers':doc.data().curOffers,
              'visits':doc.data().visits,
              'orders':doc.data().orders,
              'created': doc.data().created,
              // 'rank':doc.data().rank,
              'owner': doc.data().owner,
              //  'regemail':doc.data().email,
              // 'regtel':doc.data().telephone,
               'details': doc.data().details
          
        }
        this.shops.push(data)
        if(this.shops[0].config){
          console.log('config')
          this.changed = false
          this.fetched = true
          console.log(this.changed)
        }else{
          this.changed = true
        }
         this.loading1 = false
        
          //console.log(this.shops[0].id)
      })
    })
  },
   
}
</script>

<style scoped>
   @import url('~@/assets/admin/css/admin-loader.css');
  .bnr-img{
  width:400px;
  height: 270px;
}
@media (max-width: 575px){
  .bnr-img{
  width:250px;
  height: 165px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/admin/AdminSetting.vue